export const DevicesActionTypes = {
  API_RESPONSE_SUCCESS: '@@devices/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@devices/API_RESPONSE_ERROR',

  GET_DEVICE: '@@devices/GET_DEVICE',
  LIST_DEVICES: '@@devices/LIST_DEVICES',
  LIST_PLAYERS: '@@devices/LIST_PLAYERS',
  LIST_INTERACTIVES: '@@devices/LIST_INTERACTIVES',
  ADD_DEVICE: '@@devices/ADD_DEVICE',
  UPDATE_DEVICE: '@@devices/UPDATE_DEVICE',
  DELETE_DEVICE: '@@devices/DELETE_DEVICE',

  RESET: '@@devices/RESET'
}
